module.exports = __webpack_public_path__ + "mainassets/img/search.581358c8.svg";